import { render, staticRenderFns } from "./doubleRing.vue?vue&type=template&id=619cfb82&scoped=true&"
import script from "./doubleRing.vue?vue&type=script&lang=js&"
export * from "./doubleRing.vue?vue&type=script&lang=js&"
import style0 from "./doubleRing.vue?vue&type=style&index=0&id=619cfb82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cfb82",
  null
  
)

export default component.exports